export const notification = "/media/sound/notification_sound.mp3";